import React from "react";
import './footer.css'
const Footer = () => {
  return (
    <footer>
      <div className="source-data">
        <strong>Data: </strong>
        Semarang Demographic Data 2023 | Q1
      </div>
      <div className="created-author">© Developed by <a href="https://www.linkedin.com/in/yakubhariana/">Yakub Hariana</a></div>
    </footer>
  );
};

export default Footer;
